import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress non-critical Firebase Auth COOP warnings globally
// This must run BEFORE any other scripts to catch early errors
if (typeof window !== 'undefined') {
  // Suppress console errors for known non-critical Firebase Auth warnings
  const originalError = window.console.error;
  const originalLog = window.console.log;
  const originalWarn = window.console.warn;
  
  // Helper function to check if message should be suppressed
  const shouldSuppress = (message: string): boolean => {
    const lowerMessage = message.toLowerCase();
    return (
      lowerMessage.includes('cross-origin-opener-policy') ||
      lowerMessage.includes('window.closed') ||
      lowerMessage.includes('window.close') ||
      lowerMessage.includes('message channel closed') ||
      lowerMessage.includes('listener indicated an asynchronous response') ||
      lowerMessage.includes('popup.ts') ||
      lowerMessage.includes('abstract_popup_redirect_operation') ||
      lowerMessage.includes('functiebeleid') ||
      lowerMessage.includes('niet-ondersteunde functienaam') ||
      lowerMessage.includes('wordt overgeslagen') ||
      lowerMessage.includes('__secure-yec') ||
      (lowerMessage.includes('cookie') && (lowerMessage.includes('afgewezen') || lowerMessage.includes('cross-site')))
    );
  };
  
  window.console.error = (...args: any[]) => {
    const errorMessage = args.join(' ');
    // Suppress known non-critical Firebase Auth popup warnings
    if (shouldSuppress(errorMessage)) {
      // Suppress these non-critical warnings - they don't affect functionality
      return;
    }
    originalError.apply(window.console, args);
  };

  window.console.warn = (...args: any[]) => {
    const warnMessage = args.join(' ');
    // Also suppress warnings for the same issues
    if (shouldSuppress(warnMessage)) {
      return;
    }
    originalWarn.apply(window.console, args);
  };

  // Suppress orchestration info logs (Firebase/Service initialization)
  window.console.log = (...args: any[]) => {
    const logMessage = args.join(' ');
    // Suppress orchestration initialization logs
    if (
      logMessage.includes('orchestration:') ||
      logMessage.includes('Initializing config store') ||
      logMessage.includes('Initializing feature flag store') ||
      logMessage.includes('Initializing user store') ||
      logMessage.includes('Updating combined state')
    ) {
      // Suppress these info logs - they're just initialization messages
      return;
    }
    originalLog.apply(window.console, args);
  };

  // Also suppress unhandled promise rejections for the same errors
  window.addEventListener('unhandledrejection', (event) => {
    const errorMessage = event.reason?.message || event.reason?.toString() || '';
    if (shouldSuppress(errorMessage)) {
      // Suppress these non-critical promise rejections
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
